import { ShouldSearchStart, getTemplate, supapfolioV3Client, shopifyCollectionDescription } from './supapress-v3-utilities.js'
import SupapressV3Book from './supapress-v3-book.js'
import SupapressV3Filters from './supapress-v3-filters.js'
import { getGoogleAnalyticsUserIdFromBrowserCookie } from './supapress-v3-insights.js'
import { generalTranslations } from '../utilities'
/**
 * This class is responsible for running the Instant Search templates
 */
class SupapressV3Search {
  constructor (searchWrapperContainer) {
    this.searchWrapperContainer = searchWrapperContainer
    this.client = supapfolioV3Client()
    this.bookSearch = this.runSearchQuery()
    this.generalTranslations = generalTranslations()
  }

  searchFunction (helper) {
    if (ShouldSearchStart(helper) === false) {
      this.searchWrapperContainer.style.display = 'none'
      return
    }

    if (window.theme.settings.showCollectionDescription === 'true') {
      shopifyCollectionDescription(helper)
    }

    // don't run the search on first load if on author page
    if (document.readyState !== 'complete' && window.theme.settings.urlRequested === '/collections/vendors') {
      document.getElementById('js-supapress-v3-search-field').value = ''
      return
    }

    helper.search()

    if (window.theme.settings.enableAlgoliaInsights === 'true') {
      setTimeout(() => {
        window.dataLayer.push({ event: 'Hits Viewed' })
      }, 1000)
    }

    this.searchWrapperContainer.style.display = 'block'
  }

  showBooks () {
    // Show layout elements once results are returned has finished.
    const booksContainer = document.querySelector('.js-supapress-v3-search-books-wrapper')

    if (typeof booksContainer === 'undefined') {
      return
    }

    booksContainer.style.display = 'block'
  }

  hideLoader () {
    const loaderDiv = document.querySelector('.js-supapress-v3-loader-container')

    if (typeof loaderDiv === 'undefined') {
      return
    }

    loaderDiv.style.display = 'none'
  }

  runSearchQuery () {
    let urlSyncParams = false
    if (window.theme.settings.urlRequested !== '/collections/vendors') {
      urlSyncParams = {
        mapping: {
          p: 'spage'
        }
      }
    }

    const searchConfig = {
      source: 'products',
      urlSync: urlSyncParams,
      searchFunction: this.searchFunction.bind(this)
    }
    if (window.theme.settings.enableAlgoliaInsights === 'true') {
      const userToken = getGoogleAnalyticsUserIdFromBrowserCookie('_ga')
      searchConfig.searchParameters = { userToken, clickAnalytics: true }
      window.dataLayer.push({
        algoliaUserToken: userToken
      })
    }

    const search = this.client.search(searchConfig)
    return search
  };

  setupStats () {
    const searchStats = this.searchWrapperContainer.querySelector('.js-supapress-v3-search-stats')

    if (!searchStats) {
      return this.bookSearch.widgets
    }

    this.bookSearch.addWidget(
      this.bookSearch.widgets.stats({
        container: searchStats,
        classes: {
          wrapper: 'supapress-v3-search-stats__wrapper'
        },
        templates: {
          stats: getTemplate('js-supapress-v3-search-stats')
        }
      })
    )
  };

  setupPerPageSelector () {
    const PerPageSelectorItems = this.searchWrapperContainer.querySelectorAll('.js-supapress-v3-search-per-page')

    if (PerPageSelectorItems.length === 0) {
      return
    }

    const perPageOptions = [
      { value: 5, label: '5' },
      { value: 10, label: '10' },
      { value: 20, label: '20' },
      { value: 45, label: '50' },
      { value: 100, label: '100' }
    ]

    Array.from(PerPageSelectorItems).forEach(PerPageSelectorItem => {
      const classSelector = '.' + Array.from(PerPageSelectorItem.classList).join('.') // allows for multiple pagination items

      this.bookSearch.addWidget(
        this.bookSearch.widgets.perPageSelector({
          container: classSelector,
          autoHide: true,
          options: perPageOptions
        })
      )
    })
  }

  setupSortBy () {
    const sortByItems = this.searchWrapperContainer.querySelectorAll('.js-supapress-v3-search-sort-by')

    if (sortByItems.length === 0 || window.theme.settings.sortByOptions === '') {
      return
    }

    Array.from(sortByItems).forEach(sortByItem => {
      const classSelector = '.' + Array.from(sortByItem.classList).join('.') // allows for multiple pagination items
      const defaultOptions = [
        { value: 'publication_date_desc', label: 'newest_to_oldest' },
        { value: 'publication_date_asc', label: 'oldest_to_newest' },
        { value: 'prices_gbp_desc', label: 'highest_price' },
        { value: 'prices_gbp_asc', label: 'lowest_price' },
        { value: 'prices_eur_desc', label: 'highest_price' },
        { value: 'prices_eur_asc', label: 'lowest_price' },
        { value: 'prices_usd_desc', label: 'highest_price' },
        { value: 'prices_usd_asc', label: 'lowest_price' },
        { value: 'title_asc', label: 'title_asc' },
        { value: 'title_desc', label: 'title_desc' }
      ]
      let adminOptions = window.theme.settings.sortByOptions
      adminOptions = adminOptions.split(',')
      adminOptions = { ...adminOptions }
      let filteredOptions = defaultOptions.filter(sort => Object.values(adminOptions).includes(sort.value))
      // translate dropdown label
      filteredOptions = filteredOptions.map(option => {
        if (this.generalTranslations.search[option.label]) {
          option.label = this.generalTranslations.search[option.label]
        }
        return option
      })
      this.bookSearch.addWidget(
        this.bookSearch.widgets.sortBySelector({
          container: classSelector,
          options: filteredOptions
        })
      )
    })
  };

  setupPagination () {
    const paginationItems = this.searchWrapperContainer.querySelectorAll('.js-supapress-v3-search-pagination')

    if (paginationItems.length === 0) {
      return
    }

    Array.from(paginationItems).forEach(paginationItem => {
      const classSelector = '.' + Array.from(paginationItem.classList).join('.') // allows for multiple pagination items

      this.bookSearch.addWidget(
        this.bookSearch.widgets.pagination({
          container: classSelector,
          labels: {
            previous: '<svg aria-hidden="true" focusable="false" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg>',
            next: '<svg aria-hidden="true" focusable="false" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg>'
          },
          showFirstLast: false,
          classes: {
            wrapper: 'pagination',
            page: 'page',
            active: 'current',
            previous: 'prev',
            next: 'next'
          },
          scrollTo: '.js-supapress-v3-search-scroll-to-hook',
          scrollToTransition: true
        })
      )
    })
  };

  setupSearchForms () {
    const searchForms = document.querySelectorAll('.js-supapress-v3-search-form')

    if (searchForms.length === 0) {
      return
    }

    document.querySelector('.site-header__search .js-supapress-v3-search-form').addEventListener('input', function (e) {
      window.scrollTo(0, 0)
    })

    Array.from(searchForms).forEach(searchForm => {
      const classSelector = '.' + Array.from(searchForm.classList).join('.') // allows for multiple pagination items
      let placeholder = 'Search by title, author or ISBN'
      if (this.generalTranslations.search.placeholder_variant) {
        placeholder = this.generalTranslations.search.placeholder_variant
      }
      this.bookSearch.addWidget(
        this.bookSearch.widgets.searchBox({
          container: classSelector,
          placeholder,
          clearRefinementsOnSearch: false,
          inputID: 'js-supapress-v3-search-field',
          templates: {
            searchBox: getTemplate('js-supapress-v3-search-form')
          }
        })
      )
    })
  }

  setupSearchFilters () {
    const searchFilters = new SupapressV3Filters(this)

    searchFilters.setupClearAllFiltersButton()
    searchFilters.setupPriceFilter()
    searchFilters.setupFilters()
  }

  setupSearchListTemplate () {
    return this.bookSearch.widgets.results({
      container: '.js-supapress-v3-search-books-wrapper',
      perRow: 1,
      itemAlign: 'left',
      resultHandler: item => {
        const book = new SupapressV3Book(this, item)
        this.translateContent()
        return book.getBook()
      },
      templates: {
        item: getTemplate('js-supapress-v3-search-book'),
        empty: getTemplate('js-supapress-v3-search-no-results')
      },
      classes: {
        columns: 'supafolio-grid-columns supadu-product-grid__item small--one-half medium-up--one-fifth'
      }
    })
  }

  setupClearAllEvent (e) {
    if (e.target.classList.contains('supapress-v3-search__clear-all') === false) {
      return
    }

    document.querySelector('.supafolio-clear-all__button').click()
  }

  /**
     * shows and hides all filters on mobile
     * @param e
     */
  openCloseFilters (e) {
    if (e.target.classList.contains('js-supapress-v3-search-filters-mobile-toggle') === false) {
      return
    }

    const filtersAccordion = this.searchWrapperContainer.querySelector('.js-supapress-v3-search-filters-accordion')

    if (filtersAccordion === 'undefined') {
      return
    }

    filtersAccordion.classList.toggle('is-open')
  }

  setupCustomEvents () {
    if (typeof this.searchWrapperContainer === 'undefined') {
      return
    }
    this.searchWrapperContainer.addEventListener('click', (e) => {
      this.setupClearAllEvent(e)
      this.openCloseFilters(e)
    })
  }

  translateContent () {
    if (window.theme.settings.shopLocale === 'en') return
    const algoliaSearch = document.querySelector('.js-supapress-v3-search-template')
    // translate most relevant
    const sortBy = algoliaSearch.querySelector('#supafolio-sort-by-select')
    if (!sortBy) return
    if (sortBy.options[0] &&
      sortBy.options[0].text === 'Most relevant' &&
      !sortBy.options[0].classList.contains('translated') &&
      this.generalTranslations.search.most_relevant
    ) {
      sortBy.options[0].text = this.generalTranslations.search.most_relevant
      sortBy.options[0].classList.add('translated')
    }
  }

  async initialiseSearch () {
    if (this.client === null) {
      return
    }

    this.showBooks()
    this.hideLoader()
    this.setupPagination()

    if (window.theme.settings.showV3sortBy === 'true') {
      this.setupSortBy()
    }

    if (window.theme.settings.showV3perPage === 'true') {
      this.setupPerPageSelector()
    }

    if (window.theme.settings.showV3filters === 'true') {
      this.setupSearchFilters()
    }

    if (window.theme.settings.showV3stats === 'true') {
      this.setupStats()
    }

    this.setupSearchForms()

    this.bookSearch.addWidget(
      this.setupSearchListTemplate()
    )

    // Start Book Search
    this.bookSearch.start()

    this.setupCustomEvents()
  }
}

export default SupapressV3Search
